import { render, staticRenderFns } from "./ChapterStudioPage.vue?vue&type=template&id=20cbd328&scoped=true&"
import script from "./ChapterStudioPage.vue?vue&type=script&lang=js&"
export * from "./ChapterStudioPage.vue?vue&type=script&lang=js&"
import style0 from "./ChapterStudioPage.vue?vue&type=style&index=0&id=20cbd328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cbd328",
  null
  
)

export default component.exports